import { render, staticRenderFns } from "./fechaIngresoComponent.vue?vue&type=template&id=4484aad2"
import script from "./fechaIngresoComponent.vue?vue&type=script&lang=js"
export * from "./fechaIngresoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports